import { render, staticRenderFns } from "./CreateSpace.vue?vue&type=template&id=71d93f80&"
import script from "./CreateSpace.vue?vue&type=script&lang=js&"
export * from "./CreateSpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports